import { render, staticRenderFns } from "./order-query2.vue?vue&type=template&id=edee34f0&scoped=true&"
import script from "./order-query2.vue?vue&type=script&lang=js&"
export * from "./order-query2.vue?vue&type=script&lang=js&"
import style0 from "./order-query2.vue?vue&type=style&index=0&id=edee34f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edee34f0",
  null
  
)

export default component.exports